import useQuery from '../../../../../../../shared/hooks/useQuery';
import { getCustomFieldFilterMetadata } from '../requests/get-filter-metadata';
import { customFieldFilterMetadataAtom } from '../state';
import { CustomFieldFilterMetadata } from '../typings';

export const useFilterMetadata = (autoFetch = true) => {
  return useQuery<CustomFieldFilterMetadata>({
    requestAtom: customFieldFilterMetadataAtom,
    queryFunction: getCustomFieldFilterMetadata,
    autoFetch,
    getCachedData: true,
  });
};
